import styled from '@emotion/styled';
import React from 'react';
import { NavLink } from 'react-router';
import { Breadcrumb } from 'semantic-ui-react';

interface CrumbProps {
  inactive?: boolean;
  last: boolean;
  pathname: string;
  children: React.ReactNode;
}

export const Crumb = ({ inactive, last, pathname, children }: CrumbProps) => {
  if (inactive || last)
    return (
      <>
        <S.InactiveSection>{children}</S.InactiveSection>
        {!last && <Breadcrumb.Divider icon="right chevron" />}
      </>
    );

  return (
    <>
      <S.ActiveSection as={NavLink} to={pathname} link>
        {children}
      </S.ActiveSection>
      <Breadcrumb.Divider icon="right chevron" />
    </>
  );
};

const S = {
  InactiveSection: styled(Breadcrumb.Section)`
    font-weight: 500;
    &&& {
      font-size: 16px;
    }
  `,
  ActiveSection: styled(Breadcrumb.Section)`
    &&& {
      font-weight: 500;
      font-size: 16px;
    }
  `,
};
